export default {
    section: 'Lending Considerations',
    name: 'offer-letter-lending',
    items: [
        {
            type: 'radio-list',
            text: 'Will Buyer be using a third-party lender for the acquisition?',
            name: 'offer-letter-lending-lender',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'textarea',
                    text: 'Which lender will be used?',
                    name: 'offer-letter-lending-lender-name',
                    props: {
                        label: 'Lender Name'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-lending-lender',
                                value: 'yes'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'textarea',
            text: 'Notes',
            name: 'offer-letter-lending-notes',
            props: {}
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/offer-letter/valuation-data/lending.js